<template>
  <v-navigation-drawer
    color="black"
    :rail="isMobile ? true : rail"
    :width="200"
    permanent
    data-testid="so-navigation-drawer"
    :rail-width="isMobile ? 84 : 56"
    :class="{ 'collapsed-layout-mobile': isMobile }"
  >
    <v-list
      :color="activeColor"
      :nav="true"
      data-testid="so-navigation-drawer-list"
    >
      <div v-if="!isMobile" class="d-flex justify-end mb-2">
        <SoButton
          data-testid="so-navigation-drawer-toggle"
          type="icon"
          :icon="rail ? 'arrow-expand-right' : 'arrow-expand-left'"
          @click="sidePanelToggle"
        ></SoButton>
      </div>
      <v-list-item
        v-for="link in visibleLinks"
        :key="link.title"
        :exact="true"
        :title="link.title"
        :to="link.disabled ? undefined : link.to"
        :disabled="link.disabled"
        data-testid="so-navigation-drawer-link"
        density="compact"
      >
        <template #prepend>
          <v-badge
            v-if="link?.badge?.active"
            :color="link?.badge.status"
            :dot="!link?.badge.content"
            :content="link?.badge.content"
            :location="badgePosition"
          >
            <v-icon :icon="link.icon" />
          </v-badge>
          <v-icon v-else :icon="link.icon" />
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
  import { PropType, defineComponent } from "vue"
  import { useThemeHelper } from "@/theme/themeHelper"
  import { StatusType } from "@/types/Status"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { getUserPermissions } from "@/services-handlers/getUserPermissions"

  interface IBadge {
    active: boolean
    status: StatusType
    content?: string
  }

  interface Link {
    title: string
    icon: string
    to?: string
    badge?: IBadge
    disabled?: boolean
  }

  export default defineComponent({
    components: { SoButton },
    props: {
      links: {
        type: Array as PropType<Link[]>,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        rail: false,
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile
      },
      activeColor() {
        return useThemeHelper().colors.value.secondary
      },
      visibleLinks() {
        return this.links.filter(
          (link) => !link.to || getUserPermissions.canAccessRoute(link.to),
        )
      },
      badgePosition() {
        if (this.rail || this.isMobile) {
          return "top"
        } else {
          return "top end"
        }
      },
    },
    methods: {
      sidePanelToggle() {
        this.rail = !this.rail
      },
    },
  })
</script>

<style scoped>
  .collapsed-layout-mobile :deep(.v-list-item-title) {
    font-size: 12px;
    white-space: normal;
    text-align: center;
  }
  .collapsed-layout-mobile :deep(.v-list-item__prepend) {
    display: inline;
    text-align: center;
  }
  .collapsed-layout-mobile :deep(.v-navigation-drawer__content) {
    padding-top: 12px;
  }
  .collapsed-layout-mobile .v-list--nav {
    padding-inline: 0;
  }
  .collapsed-layout-mobile .v-list-item {
    border-radius: 0;
    min-height: 58px;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
</style>
